import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MenuConfig } from "../menuConfig";

export function useActiveMenu(
  businessType: string,
  isEmployee: boolean,
  menuConfig: MenuConfig,
) {
  const [activeMenu, setActiveMenu] = useState("");
  const navigate = useNavigate();
  const location = useLocation(); // 👈 dynamic route detection

  // Restore from sessionStorage on mount
  useEffect(() => {
    const savedMenu = sessionStorage.getItem("activeMenu");
    if (savedMenu) setActiveMenu(savedMenu);
  }, []);

  // Sync with current route path
  useEffect(() => {
    const path = location.pathname;

    const menuMappings: { title: string; path?: string }[] = [
      {
        title: "Home",
        path: isEmployee ? menuConfig.employeeHomePath : menuConfig.homePath,
      },
      {
        title: "Dashboard",
        path: isEmployee
          ? (menuConfig.employeeDashboardPath ?? menuConfig.dashboardPath)
          : menuConfig.dashboardPath,
      },
      {
        title: "Orders",
        path: isEmployee
          ? (menuConfig.employeeOrderPath ?? menuConfig.orderPath)
          : menuConfig.orderPath,
      },
      {
        title: "Ledgers",
        path: isEmployee
          ? menuConfig.employeeLedgerPath
          : menuConfig.ledgerPath,
      },
      {
        title: "Reports",
        path: menuConfig.DailyReport,
      },
      {
        title: "Catalog",
        path: menuConfig.Catalog,
      },
      {
        title: "Admin",
        path: menuConfig.settingsPath,
      },
      {
        title: "Configurations",
        path: menuConfig.Configurations,
      },
      {
        title: "Tools",
        path: menuConfig.toolsPath,
      },
      {
        title: "Running Order",
        path: menuConfig.runningOrder,
      },
       { title: "Drafts", path: menuConfig.Draft },
    ].filter((m) => !!m.path);

    // Find matching menu (you can also use startsWith for partial matches)
    const matched = menuMappings.find((m) => m.path && path.startsWith(m.path));

    if (matched) {
      setActiveMenu(matched.title);
      sessionStorage.setItem("activeMenu", matched.title);
    } else {
      // 👇 Route doesn’t belong to menu — clear active highlight
      setActiveMenu("");
      sessionStorage.removeItem("activeMenu");
    }
  }, [location.pathname, businessType, isEmployee, menuConfig]);

  const handleMenuClick = (title: string, path?: string) => {
    setActiveMenu(title);
    sessionStorage.setItem("activeMenu", title);
    if (path) navigate(path);
  };

  return { activeMenu, handleMenuClick };
}
